import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getDomainTheme } from '../constants/theme';

class MsisdnNotFound extends Component {
    render() {
        const { productName } = getDomainTheme();
        return (
            <Container className="restricted">
                <Row className="justify-content-center">
                    <Col md="6">
                        <div className="clearfix">
                            <h1 className="float-left display-3 mr-4 red-text-color"><i className="fa fa-warning"></i></h1>
                            <h4 className="pt-2 magenta-text-color">
                                {this.props.reason}
                            </h4>
                            <p className="red-text-color float-left">
                                Subscribe now to {productName} for unlimited access to all our content!
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}


export default MsisdnNotFound;



// WEBPACK FOOTER //
// ./src/components/MsisdnNotFound.js